// This file configures the initialization of Sentry on the browser.
// The config you add here will be used whenever a page is visited.
// https://docs.sentry.io/platforms/javascript/guides/nextjs/

;globalThis["_sentryRewritesTunnelPath"] = undefined;globalThis["SENTRY_RELEASE"] = {"id":"d8ffce8cdbb52c928fb2d78a6f9af7d52fe06ab1"};globalThis["_sentryBasePath"] = undefined;globalThis["_sentryRewriteFramesAssetPrefixPath"] = "";import * as Sentry from "@sentry/nextjs";

const SENTRY_DSN = process.env.SENTRY_DSN || process.env.NEXT_PUBLIC_SENTRY_DSN;

Sentry.init({
  dsn:
    SENTRY_DSN ||
    "https://28e190d2aeda41a792f93a44f2404bed@o158608.ingest.sentry.io/4504036848107520",
  integrations: [Sentry.replayIntegration()],
  tracesSampleRate: 0,
  replaysSessionSampleRate: 0,
  replaysOnErrorSampleRate: 1.0,
  environment: process.env.COMMIT_REF,
  release: process.env.COMMIT_SHA,
  enabled: process.env.NODE_ENV === "production",
  ignoreErrors: ["Cancel rendering route", "No error message"],
});
